import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageNewMock, HomepageNewMock1, HomepageNewMock2} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (p: any, store: any) => {
    // if (p?.mock) return HomepageNewMock2
    // return HomepageNewMock1
    const resp = await http.post(
      '/live/activity/year_game_2025_homepage',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)
const initialState: {
  homepage?: {
    is_act?: boolean
    status?: number
    is_show?: boolean
    main_stage_tag_list?: number[]
    cur_main_score?: number
    cur_main_stage?: number
    cur_pool_coins?: number
    cur_contribution?: number
    prop_harm?: number
    cur_prop_num?: number
    bet_prop_need?: number
    main_start_time?: string
    main_end_time?: string
    date_ex?: number
    reward_record?: {
      mid?: number
      damage?: number
      stage_id?: number
      rank_no?: number
      reward_time?: string
      reward_coins?: number
      rewards?: {
        icon?: number
        id?: number
        desc?: string
        has_show_effect?: boolean
      }[]
    }[]
    rank_rewards?: {
      icon?: number
      id?: number
      desc?: string
      has_show_effect?: boolean
    }[]
    need_pop?: boolean
    is_first_enter?: boolean
    round_list?: number[]
  }
  isShowPopup?: boolean
} = {
  homepage: {},
  isShowPopup: false,
}

export const AnnualGame2025Slice = createSlice({
  name: 'AnnualGame2025',
  initialState,
  reducers: {
    setIsShowPopup: (state, action) => {
      Object.assign(state, {
        isShowPopup: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      Object.assign(state?.homepage, action.payload)
    })
  },
})

export default AnnualGame2025Slice.reducer
export const AnnualGame2025Actions = AnnualGame2025Slice.actions
